import React from 'react';
import axios from "axios";
import packageJson from '../../package.json';
import {getUUID} from "./hashFuncs";

global.appVersion = packageJson.version;

const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

export default class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false
        }

        this.refreshCacheAndReload = () => {
            console.log('Clearing cache and hard reloading...')
            if (caches) {
                // Service worker cache should be cleared with caches.delete()
                caches.keys().then((names) => {
                    for (let name of names) caches.delete(name);
                });
            }

            let randomint = Math.round(Math.random() * 1000)
            // delete browser cache and hard reload

            if (window.location.href.includes('cb=')) {
                // prevent infinite loop
                return;
            }

            window.location = window.location.href +
                (window.location.href.includes('?') ? '&' : '?') +
                'cb='+randomint;
        }
    }


    componentDidMount() {

        if (window.location && window.location.toString().includes('cb=')) return;

        axios.get(`/meta.json?uu=${getUUID()}`)
            .then((response) => response.data)
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;

                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.refreshCacheAndReload();
                    this.setState({ loading: false, isLatestVersion: false });
                } else {
                    console.log(`You already on version ${latestVersion}.`);
                    this.setState({ loading: false, isLatestVersion: true });
                }
            });
    }

    render() {
        return <></>
    }
}
